export default __webpack_public_path__ + "static/media/bgh.1d41d71f.png";